import { render } from "./MainSidebar.vue?vue&type=template&id=6f7b043d&ts=true"
import script from "./MainSidebar.vue?vue&type=script&lang=ts"
export * from "./MainSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Layouts/MainSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f7b043d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f7b043d', __exports__)) {
    api.reload('6f7b043d', __exports__)
  }
  
  module.hot.accept("./MainSidebar.vue?vue&type=template&id=6f7b043d&ts=true", () => {
    api.rerender('6f7b043d', render)
  })

}


export default __exports__